export default "__VITE_ASSET__DL7Kc7Je__"